var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"printPage--header"},[_vm._v(" WordSearch - "+_vm._s(_vm.formatedDate)+" ")]),_c('div',{staticClass:"printPage--gridWordWrapper"},[_c('PrintWordList'),_c('PrintPuzzleGrid')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }